import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { List, Segment } from 'semantic-ui-react';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import AppForm from '../../../components/forms/appForms/AppForm';
import StatusLabels from '../../../components/sem/cards/StatusLabels';
import { appFormTypes } from '../../../enums/appFormTypes';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import { DataModificationsContext } from '../UiDataModifications';

const _allowCommit = true

/** Component for Ammending Data 
  @description updates using (handleAmmendDataItems, handleDelete_dataItems)
 */
const UiStatus = () => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { clientInfo_state, paps_state } = states
  const { clientInfo_handlers } = handlers
  const { appArea } = paps_state
  const { clientEvents, clientEventsStatus, selectedEvent, updating } = clientInfo_state

  // dataModificationsContext
  const dataModificationsContext = useContext(DataModificationsContext)
  const { dataModifications_state } = dataModificationsContext ?? {}
  const { appData } = dataModifications_state ?? {}

  // local state  
  const [mainCaption] = useState(_.startCase(appArea) + ' Status')

  useEffect(() => {
    const _appData = _.orderBy(_.cloneDeep(appData), ['startTimeUTC'], ['desc'])
    clientInfo_handlers.handleSet_clientEventsStatus(_appData)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [appData]);

  // commits to the database
  const handleSaveAll = () => {
    clientInfo_handlers.handleStartUpdate()
    clientInfo_handlers.handleUpdate_clientEventsStatus(clientEventsStatus)
  }

  // commits to the database
  const handleCommit = () => {
    if (_allowCommit) {
      clientInfo_handlers.handleStartUpdate()
      clientInfo_handlers.handleUpdate_clientEvent(selectedEvent)
    }
  }

  const handleGetEventsInfo = () => {
    const cb = (data, latest, clientEventsStatus) => {
      clientInfo_handlers.handleSet_clientEvents(data, latest, clientEventsStatus)
    }
    clientInfo_handlers.handleStartUpdate()
    clientInfo_handlers.handleGet_eventsInfo(cb)
  }

  const handleClick_unselectEvent = () => clientInfo_handlers.handleShow_selectedClientEvent()
  const handleClick_selectEvent = (itemData) => clientInfo_handlers.handleShow_selectedClientEvent(itemData)
  const handleUpdateSelectedItem = (d) => clientInfo_handlers.handleShow_selectedClientEvent(d)

  const handleStatusChange = (e, data) => {
    e.stopPropagation()
    const _clientEventsStatus = [...clientEventsStatus]
    const item = _.find(_clientEventsStatus, { _itemKey: data.itemkey })
    item.eventStatusType = data.value
    clientInfo_handlers.handleSet_clientEventsStatus(_clientEventsStatus)
  }

  const list = () => {
    if (!clientEventsStatus) return []
    const sortedLis = _.orderBy(clientEventsStatus, ['name'], ['asc']);
    const lis = _.map(sortedLis, (itemData) => {
      const { name, _itemKey } = itemData
      return <List.Item onClick={() => handleClick_selectEvent(itemData)}>
        <List.Content>
          <List.Header >{name}</List.Header>
          <List.Description>{_itemKey}</List.Description>
          <List.Description >
            <StatusLabels itemData={itemData} handleStatusChange={handleStatusChange} />
          </List.Description>
        </List.Content>
      </List.Item>
    })
    return <Segment basic>
      <List divided relaxed className={'client-status'}>{lis}</List>
    </Segment>
  }

  const form = () => <AppForm
    appFormType={appFormTypes.eventStatus}
    data_parent={selectedEvent}
    handleSaveCaption={'Update Status'}
    handleUpdateParentData={handleUpdateSelectedItem}
  ></AppForm>

  const footer_list = () => {
    const btns = []
    btns.push({ oc: handleGetEventsInfo, caption: 'Refresh Event Info', icon: 'arrow right', fl: true })
    btns.push({ oc: handleSaveAll, caption: 'Update All', icon: 'save', color: 'green' })
    return <UiSaveButtons others={btns} />
  }

  const footer_item = () => {
    const btns = []
    btns.push({ oc: handleClick_unselectEvent, caption: 'Back', icon: 'arrow left', color: 'black', fl: true })
    btns.push({ oc: handleCommit, caption: 'Update Status', icon: 'save', color: 'green' })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_selected = () => <Wrapper
    content={form()}
    footer={footer_item()}
    wrapperType={wrapperTypes.paddedHeader}
    updating={updating}
  />

  const wrapper_list = () => <Wrapper
    content={list()}
    footer={footer_list()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    updating={updating}
    css={{ container: 'app-dark-mode' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={selectedEvent ? wrapper_selected() : wrapper_list()}
    topperCaption={mainCaption}
    topperCaption2={selectedEvent ? selectedEvent.name : null}
    handleCancel={selectedEvent ? handleClick_selectEvent : null}
    isBack={selectedEvent ? true : false}
  />

  return fullPageWrapper()
}

export default UiStatus